module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "support-body"
  }, [_c('div', {
    staticClass: "support-container"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/nav_logo_primary.png",
      "alt": "YouSound Logo"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("YouSound Support")]), _vm._v(" "), _c('div', {
    staticClass: "contact"
  }, [_vm._v("\n      If you have questions please reach out to us at:\n      "), _c('br'), _c('a', {
    attrs: {
      "href": "mailto:support@yousound.com"
    }
  }, [_vm._v("support@yousound.com")])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n      We’re currently in an early release phase, so responses may take a bit\n      longer than usual. Stay tuned as we expand our support team soon!\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4d0ff34","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/supportPage/index.vue
// module id = 1871
// module chunks = 180